import type Alpine from "alpinejs";

export function registerLightbox(A: typeof Alpine) {
  A.data("momaLightbox", (images: string[] = []) => ({
    images,
    open: false,
    index: 0,

    show(idx: number) {
      this.index = idx;
      this.open = true;
      document.documentElement.style.overflow = "hidden";
    },

    close() {
      this.open = false;
      document.documentElement.style.overflow = "";
    },

    next() {
      this.index = (this.index + 1) % this.images.length;
    },
    prev() {
      this.index = (this.index - 1 + this.images.length) % this.images.length;
    },

    onKey(e: KeyboardEvent) {
      if (!this.open) return;
      if (e.key === "Escape") this.close();
      if (e.key === "ArrowRight") this.next();
      if (e.key === "ArrowLeft") this.prev();
    },
  }));
}
